<template>
    <div class="h-full w-full flex flex-col">
        <InternshipForm mode="edit" :selected-item="selectedItem" :get-all-partners="getAllPartners" :get-academic-year-terms="getAcademicYearTerms" @close="$emit('close')" @updated="$emit('updated')" @view-student-profile="viewStudentProfile" @review="review" />
    </div>
</template>

<script>
import InternshipForm from "./form.vue";
export default {
    name: "internship-edit",
    emits: ["updated", "view-student-profile", "review"],
    components: { InternshipForm, },
    props: ["selectedItem", "getAllPartners", "getAcademicYearTerms"],
    methods: {
        viewStudentProfile(studentId) {
           this.$emit('view-student-profile', studentId);
        },
        review(formData) {
            this.$emit('review', formData);
        }
    },
}
</script>